const formatAddress = addressStringSeparatedByComma =>
  addressStringSeparatedByComma
    .split(' ')
    .join('')
    .split(',')
    .filter(item => !['null', 'false', 'undefined', ''].includes(item))
    .join(', ');

export default formatAddress;
